export const API_URL_LEAGUES = 'https://api-football-v1.p.rapidapi.com/v3/leagues'
export const API_URL_TEAMS = 'https://api-football-v1.p.rapidapi.com/v3/teams';
export const API_URL_TEAM_SEASONS = 'https://api-football-v1.p.rapidapi.com/v3/teams/seasons';
export const API_URL_PLAYERS = 'https://api-football-v1.p.rapidapi.com/v3/players';
export const RAPIDAPI_HOST = 'api-football-v1.p.rapidapi.com';
export const API_KEY = '0ecaca6132msh9e8ca3e8ea4d7ecp1ae309jsn784eab194d80';
export const DEFAULT_SEASON = 2021;
export const RESULTS_PER_PAGE = 22;
export const LEAGUES_BTN_TEXT = 'CHOOSE LEAGUE';
export const TEAMS_BTN_TEXT = 'CHOOSE TEAM';

// League ID's
// Ligat haal: 383
// Premier League: 39
// Serie A: 135
// Ligue 1: 61
// La Liga: 140
// Bundesliga: 78
// Champions League: 2